<template>
    <div class="view" :class="{ 'd-flex': !display.mobile.value }">
        <Sidebar v-if="!display.mobile.value" />
        <Headbar v-if="display.mobile.value" />
        <div class="wrapper">
            <router-view></router-view>
        </div>
    </div>
</template>

<script>
import { useDisplay } from "vuetify/lib/composables/display";

import Sidebar from "@/components/sidebar";
import Headbar from "@/components/headbar";
export default {
    name: "base_index",
    setup() {
        const display = useDisplay();
        return { display };
    },
    components: {
        Sidebar,
        Headbar,
    },
};
</script>

<style lang="scss">
.view {
    height: 100%;
}
</style>